export default {
  SYNCHRONIZE_POLICIES_ALL: 'SYNCHRONIZE ALL POLICIES',
  SYNCHRONIZE_SIMPLE_POLICIES_ALL: 'SYNCHRONIZE ALL SIMPLE POLICIES',
  SYNCHRONIZE_ENTITIES_ALL: 'SYNCHRONIZE ALL ENTITIES',
  HEARTBEAT_SIMPLE_POLICIES_ALL: 'HEARTBEAT ALL SIMPLE POLICIES',
}
